import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DrawerPanelService {

  private collapseDrawerSubject = new BehaviorSubject<boolean>(false);
  private showFilterPanelSubject = new BehaviorSubject<boolean>(false);

  get collapseDrawer$(): Observable<boolean> {
    return this.collapseDrawerSubject.asObservable();
  }

  get showFilterPanel$(): Observable<boolean> {
    return this.showFilterPanelSubject.asObservable();
  }

  collapseDrawer(collapse: boolean): void {
    this.collapseDrawerSubject.next(collapse);
  }

  showFilterPanel(showPanel: boolean): void {
    this.showFilterPanelSubject.next(showPanel);
  }
}